import {
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from "@mui/material";
import React, { useState } from "react";
import BreadCrumbsHeader from "../../../components/BreadCrumbsHeader";
import { useQuery } from "@tanstack/react-query";
import UserQuery from "../../../stateQueries/User";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import CustomNoRowsOverlay from "../../../components/CustomNoRowsOverlay";
import DownloadIcon from "@mui/icons-material/Download";
import AddEditBoardReflectionModal from "../../../components/Modals/AddEditBoardReflectionModal";
import DeleteBoardReflectionModal from "../../../components/Modals/DeleteBoardReflectionModal";

const BoardReflections = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Query for board reflections
  const { data, isLoading } = useQuery({
    queryKey: ["boardReflections"],
    queryFn: async () => {
      return await UserQuery.CSEQuery.getAllBoardReflections();
    }
  });

  const handleDownload = (documentURL) => {
    if (documentURL) {
      window.open(
        `${process.env.REACT_APP_API_URL}/api/dev/admin/board-reflection/download?filename=${documentURL}`,
        "_blank"
      );
    }
  };

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Stack spacing={3}>
      <BreadCrumbsHeader
        title="Welcome back Tiyisela Themba Makamu"
        menus={[
          { name: "Dashboard", url: "/dashboard" },
          { name: "Website Management", url: "/websiteManagement" },
          { name: "Board Reflections", url: "/cse/boardReflections" }
        ]}
        sx={{ mb: 2 }}
      />

      <Stack direction="row" justifyContent="center" alignItems="center">
        <AddEditBoardReflectionModal />
      </Stack>

      <TableContainer component={Paper}>
        <Table aria-label="board reflections table">
          <TableHead sx={{ backgroundColor: "background.paper" }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{ fontWeight: "bolder", width: 80 }}
              >
                No#
              </TableCell>
              <TableCell sx={{ fontWeight: "bolder" }}>Title</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Period
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Document
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Date Created
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Date Updated
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.boardReflections && data?.boardReflections.length > 0 ? (
              (rowsPerPage > 0
                ? data?.boardReflections.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : data?.boardReflections
              ).map((reflection, index) => (
                <TableRow key={reflection.id}>
                  <TableCell align="center">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell>{reflection.title}</TableCell>
                  <TableCell align="center">{reflection.period}</TableCell>
                  <TableCell align="center">
                    {reflection.documentURL ? (
                      <Tooltip title="Download Document">
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleDownload(reflection.documentURL)}
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {new Date(reflection.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell align="center">
                    {new Date(reflection.updatedAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" justifyContent="center" spacing={1}>
                      <AddEditBoardReflectionModal reflection={reflection} />
                      <DeleteBoardReflectionModal reflection={reflection} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>
                  <CustomNoRowsOverlay description="No Board Reflections Available" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {data?.boardReflections && data?.boardReflections.length > 0 && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, { label: "All", value: -1 }]}
                  colSpan={7}
                  count={data?.boardReflections?.length || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page"
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default BoardReflections;
